"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _AbstractPermissionComponent = _interopRequireDefault(require("../components/AbstractPermissionComponent"));

var _utilityFunctions = require("../util/utilityFunctions");

var badArgumentMessage = 'The `hasValueSelector` argument to makeSimplePermissionComponent must be a function';

var _default = function _default(hasValueSelector) {
  (0, _utilityFunctions.invariant)((0, _utilityFunctions.isFunction)(hasValueSelector), badArgumentMessage);

  var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
      permission: hasValueSelector(state, ownProps)
    };
  };

  return (0, _reactRedux.connect)(mapStateToProps)(_AbstractPermissionComponent.default);
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/permission-components/static-1.43/js/factories/makeSimplePermissionComponent.js
// module id = 663
// module chunks = 209 210 211 212